import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import AdminLayout from '@components/layout/AdminLayout.tsx';
import { PermissionTypesEnum } from '@mock/Permissions.ts';
import ProductImageFilters from '../../features/admin/product-images/ProductImageFilters.tsx';
import ProductImageList from '../../features/admin/product-images/ProductImageList.tsx';
import ProductImageDetail from '../../features/admin/product-images/ProductImageDetail.tsx';
import { z } from 'zod';
import { useProductImageListStore } from '@features/admin/product-images/productImageListStore.ts';

const searchSchema = z.object({
  page: z.number().optional().default(1),
});

export const Route = createFileRoute('/admin/product-images')({
  validateSearch: v => searchSchema.parse(v),
  component: RouteComponent,
  beforeLoad: ctx => {
    useProductImageListStore.getState().fetchProducts({
      page: ctx.search.page,
    });
  },
});

function RouteComponent() {
  const { t } = useTranslation('admin');
  const nav = Route.useNavigate();

  const handlePageChange = (page: number) => {
    nav({
      search: s => ({ ...s, page }),
    });
  };

  return (
    <AdminLayout title={t('productImages.pageTitle')} oneOfPermission={[PermissionTypesEnum.ADMIN_PRODUCT_READ]}>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{t('productImages.pageTitle')}</h1>
          <p className="mt-1 text-sm text-gray-600">{t('productImages.pageDescription')}</p>
        </div>

        <ProductImageFilters />
        <ProductImageList handlePageChange={handlePageChange} />
        <ProductImageDetail />
      </div>
    </AdminLayout>
  );
}
